import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectBonusProcessingTransactionsEndDate, selectBonusProcessingTransactionsStartDate, selectBonusProcessingTransactionsWithAccrual } from "../../model/selectors"
import { setEndDate, setStartDate, setWithAccrual } from "../../model"
import DatePicker from "react-datepicker"
import CalendarIcon from "@/shared/assets/images/CalendarBlank.svg"
import { Select } from "@/shared/ui/select/select"

const accrualOptions = [
    { value: 'all', label: 'Все' },
    { value: 'true', label: 'С начислением' },
    { value: 'false', label: 'Без начисления' }
]

export const TransactionsFilters = () => {
    const endDate = useAppSelector(selectBonusProcessingTransactionsEndDate)
    const startDate = useAppSelector(selectBonusProcessingTransactionsStartDate)
    const withAccrual = useAppSelector(selectBonusProcessingTransactionsWithAccrual)
    const dispatch = useAppDispatch()

    const handleDateRangeChange = (value: [Date, Date]) => {
        const [start, end] = value
        dispatch(setStartDate(start))
        dispatch(setEndDate(end))
    }

    return (
        <div className="grid grid-cols-12 gap-2">
            <div className="col-span-12 md:col-span-8">
                <DatePicker 
                    selected={startDate}
                    startDate={startDate}
                    onChange={handleDateRangeChange}
                    endDate={endDate}
                    selectsRange
                    wrapperClassName="react-datepicker-filterlike"
                    dateFormat={"dd.MM.yyyy"}
                    showIcon
                    enableTabLoop={false}
                    popperProps={{
                        placement: 'bottom'
                    }}
                    icon={(<CalendarIcon width={24} height={24}/>)}
                />
            </div>
            <div className="col-span-12 md:col-span-4">
                <Select
                    value={withAccrual}
                    onChange={(value) => dispatch(setWithAccrual(value))}
                    options={accrualOptions}
                />
            </div>
        </div>
    )
}
